import React from 'react'
import { ProvideEntities, ProvideEntitiesProps } from './ProvideEntities'
import { FuzzyResourcesFilter } from './FuzzyResourcesFilter'
import { SortedEntitiesBasedOnSelection } from './SortedEntitiesBasedOnSelection'
import {
  SelectedEntitiesContext,
  SelectedResourcesContextType
} from './context'
import { SearchableItem } from './SelectEntitiesForm.types'
import { SelectEntitiesFormController } from './SelectEntitiesFormController'
import { useMapMutableProps } from '../../../app/hooks/useMapMutableProps'

type SelectEntitiesFormProps = {
  selectedIds: SearchableItem['id'][]
  setSelectedIds: (ids: SelectEntitiesFormProps['selectedIds']) => void
} & ProvideEntitiesProps

const mapArrToSet = <T,>(values: T[]): Set<T> => new Set<T>(values)
const FIELDS_TO_SEARCH_PATHWAYS = ['text', 'original.workspace.name']

// If you need to support recurring events use EventSelector component instead of this

export const SelectEntitiesForm: React.FC<SelectEntitiesFormProps> = ({
  entities,
  entityType,
  selectedIds,
  setSelectedIds,
  loadEntities
}) => {
  const [selectedIdsAsSet] = useMapMutableProps(selectedIds, mapArrToSet)

  const selectedResourcesContext =
    React.useMemo((): SelectedResourcesContextType => {
      return {
        selectedIds: selectedIdsAsSet,
        setSelectedIds: (ids: Set<SearchableItem['id']>) => {
          setSelectedIds([...ids])
        }
      }
    }, [selectedIdsAsSet, setSelectedIds])
  return (
    <SelectedEntitiesContext.Provider value={selectedResourcesContext}>
      <ProvideEntities
        entities={entities}
        entityType={entityType}
        loadEntities={loadEntities}
      >
        <FuzzyResourcesFilter fields={FIELDS_TO_SEARCH_PATHWAYS}>
          <SortedEntitiesBasedOnSelection>
            <SelectEntitiesFormController />
          </SortedEntitiesBasedOnSelection>
        </FuzzyResourcesFilter>
      </ProvideEntities>
    </SelectedEntitiesContext.Provider>
  )
}
